module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/client/client.html
// module id = 701
// module chunks = 0